import script from "./MedicalNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicalNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./MedicalNoteForm.vue?vue&type=style&index=0&id=820f5c18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-820f5c18"]])

export default __exports__